import { render, staticRenderFns } from "./side-drawer.vue?vue&type=template&id=78441e30&scoped=true"
import script from "./side-drawer.vue?vue&type=script&lang=js"
export * from "./side-drawer.vue?vue&type=script&lang=js"
import style0 from "./side-drawer.vue?vue&type=style&index=0&id=78441e30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78441e30",
  null
  
)

export default component.exports